module.exports = __webpack_public_path__ + "media/images/emblems/Chessel-coat_of_arms-41df6622ddedd3454092ad08ec961cdf.svg";